import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./chip.css.ts.vanilla.css-mistica.js";
var c = "_1y2v1nf5z _1y2v1nf78 _1y2v1nf8h _1y2v1nf9q _1y2v1nfdn _1y2v1nf5y", t = {
    light: "cc7htnb cc7htn9",
    dark: "cc7htnc cc7htn9"
}, f = {
    default: "cc7htn1 _1y2v1nfb6 _1y2v1nfbe _1y2v1nfbk _1y2v1nfdm _1y2v1nf31 _1y2v1nf1w",
    overAlternative: "cc7htn1 _1y2v1nfb6 _1y2v1nfbe _1y2v1nfbk _1y2v1nfdm _1y2v1nf38 _1y2v1nf1w",
    active: "cc7htn8 cc7htn2 cc7htn1 _1y2v1nfb6 _1y2v1nfbe _1y2v1nfbk _1y2v1nfdm _1y2v1nf16 _1y2v1nf5k"
}, y = "cc7htnd", _ = "cc7htne";
export { c as button, t as chipInteractiveVariants, f as chipVariants, y as icon, _ as iconActive };
